var map = {
	"./avatar0.svg": 754400,
	"./avatar1.svg": 990353,
	"./avatar2.svg": 569986,
	"./avatar3.svg": 75155,
	"./avatar4.svg": 141260,
	"./avatar5.svg": 340205,
	"./avatar6.svg": 491854,
	"./avatar7.svg": 320287,
	"./avatar8.svg": 117400,
	"./avatar9.svg": 421641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204904;